export default {
  props: {
    config: Object
  },
  data () {
    return {
      form: { ...this.config },
      debounceTimer: null
    }
  },
  methods: {
    change () {
      this.$emit('update:config', this.form)
      this.$nextTick(() => this.$emit('change'))
    },
    changeDebounce () {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      this.debounceTimer = setTimeout(() => this.change(), 2000)
    }
  },
  watch: {
    config (value) {
      this.form = { ...value }
    }
  }
}
